import * as React from 'react';
import { withRouter } from "react-router-dom";
import OrganizationForm from '../components/OrganizationForm';

const OrganizationGeneralSettings = (props: any) => {
  return (
    <OrganizationForm />
  )
}

export default withRouter(OrganizationGeneralSettings)


// WEBPACK FOOTER //
// ./src/modules/organization/pages/OrganizationSettings.tsx